import React from 'react';

// components
import {Skeleton} from '@mui/joy';
import {CardBorder} from '../../CardBorder';

// styles
import {
  MobileWrapper,
  MobileCircleWrapper,
  MobileContent,
} from '../CardDetails-styles';
import {useTheme} from '@emotion/react';
import {LabelContentHorizontalSkeleton} from '../../LabelContentHorizontal';
import {Columns} from './types';

// types

type Props = {
  columns: Columns;
  variant: 'summary' | 'detailed';
};

const CardDetailsSkeletonMobile = ({columns, variant}: Props) => {
  const {skeleton} = useTheme();

  return (
    <CardBorder variant="white" hasShadow>
      <MobileWrapper>
        {variant === 'summary' && (
          <Skeleton variant="text" width={skeleton.text.width.lg} />
        )}
        <MobileCircleWrapper>
          <Skeleton variant="circular" width={142} height={142} />
        </MobileCircleWrapper>
        <MobileContent>
          {columns.map(({headerWidth, contentWidth}, index) => (
            <LabelContentHorizontalSkeleton
              key={index}
              headerWidth={headerWidth}
              contentWidth={contentWidth}
              isFullWidth
            />
          ))}
        </MobileContent>
      </MobileWrapper>
    </CardBorder>
  );
};

export default CardDetailsSkeletonMobile;
